/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class ShipmentStatusVoModel extends JSONable {
  shipmentUuid: string | undefined = undefined;
  status: string | undefined = undefined;
  comments: string | undefined = undefined;
  actionedByUser: string | undefined = undefined;
  achievedAt: string | undefined = undefined;
}
